<template>
<div class="chapter">
<div class="inner_page">
<div class="ded"><i>To Soledad Lugo and Enrique García Murguía, whose memory is my medicine, and for Marisol Mineya Murguía, so she will always remember</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?22c2d3b6